<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import Login from './components/Login.vue'

// function bodyScale() {
//   const devicewidth = document.documentElement.clientWidth;//获取当前分辨率下的可是区域宽度
//   document.body.style.zoom = devicewidth / 3000;//放大缩小相应倍数
// }

// bodyScale();

export default {
  name: 'app',
  components: {
    Login
  }
}
</script>

<style>

* {
  margin: 0;
  padding: 0;
}

.pointer {
  cursor: pointer
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
